<div class="container">
  <div class="row image-collection">
    <div class="col-6" *ngFor="let image of images">
      <div class="card"
           style="width: 100%;"
           [class.selected]="image.constituentImageLibraryId === currentImage?.constituentImageLibraryId"
           (click)="selectImage(image)">
        <img class="card-img-top" [src]="image.imagePath" alt="{{ image.imageName }}">
      </div>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-end">
    <div class="btn-group row mr-0" role="group">
      <div class="d-flex">
        <button type="button" class="btn btn-outline-primary btn-block mr-2" (click)="activeModal.dismiss('Close click')">Cancel</button>
        <button type="button" class="btn btn-primary mr-2 ui-save-image" (click)="save()">{{ saveBtnLabel }}</button>
      </div>
    </div>
  </div>
</div>